import { Retriever, IState, ITimeZoneObservable, IClock } from "../../../../../common";
import { SportModel } from "../../../model";
import { EventsCountByTagRequest } from "sb-resp-lib";
import { LiveStreamingBaseRetriever } from "..";
import { liveStreamingQueryFactoryWithDate } from "../../../queries";

export class TodayLiveStreamingRetriever extends Retriever<SportModel> {

    private readonly baseRetriever: LiveStreamingBaseRetriever;
    private readonly timeZoneObservable: ITimeZoneObservable;
    private readonly clock: IClock;
    private readonly queryFactory: liveStreamingQueryFactoryWithDate;

    constructor(baseRetriever: LiveStreamingBaseRetriever, timeZoneObservable: ITimeZoneObservable, clock: IClock, queryFactory: liveStreamingQueryFactoryWithDate) {
        super();
        this.baseRetriever = baseRetriever;
        this.timeZoneObservable = timeZoneObservable;
        this.clock = clock;
        this.queryFactory = queryFactory;
    }

    async activate(state: IState<SportModel>) {
        this.baseRetriever.activate();
        await this.timeZoneObservable.observe((timezone) => {
            const requestProvider = () => this.getRequest(timezone);
            return this.baseRetriever.refresh(state, requestProvider)
        });
    }

    private getRequest(timeZone: number): EventsCountByTagRequest {
        const from = this.clock.getBeginningOfTodayForTimeZone(timeZone);
        return this.queryFactory(from);
    }

    deactivate() {
        this.baseRetriever.deactivate();
    }
}